import { render, staticRenderFns } from "./my_question.vue?vue&type=template&id=10e6127c&"
import script from "./my_question.vue?vue&type=script&lang=js&"
export * from "./my_question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports